
export const GLOBAL_NAMESPACE = 'teamerp.';
export const AUTHORIZATION = GLOBAL_NAMESPACE + 'authorization';
export const REMEMBER_USERNAME = GLOBAL_NAMESPACE + 'username';
export const REMEMBER_MOBILE = GLOBAL_NAMESPACE + 'mobile';
export const REMEMBER_PASSWORD = GLOBAL_NAMESPACE + 'password';
export const REMEMBER_TAG = GLOBAL_NAMESPACE + 'remember';
export const REMEMBER_MOBILE_TAG = GLOBAL_NAMESPACE + 'remember_mobile';
export const PROJECT_UUID = GLOBAL_NAMESPACE + 'project_uuid';
export const PROJECT_NAME = GLOBAL_NAMESPACE + 'project_name';

export const USER_ID = GLOBAL_NAMESPACE + 'user_id';
export const USER_UUID = GLOBAL_NAMESPACE + 'user_uuid';
export const USER_NAME = GLOBAL_NAMESPACE + 'user_name';
export const USER_PROJECT_ID = GLOBAL_NAMESPACE + 'user_project_id';
export const USER_META = GLOBAL_NAMESPACE + 'user_meta';
export const USER_MOBILE = GLOBAL_NAMESPACE + 'user_mobile';
export const AVATAR = GLOBAL_NAMESPACE + 'avatar';
export const AUTHORITY = GLOBAL_NAMESPACE + 'authority';
export const CURRENT_URL = GLOBAL_NAMESPACE + 'current_url';
// 记录每个项目最后打开的页面路由
export const PROJECT_URLS = GLOBAL_NAMESPACE + 'project_url';
// 记录最后打开的url
export const LAST_URL = GLOBAL_NAMESPACE + 'last_url';
// 文档历史记录
export const HISTORY_KEY = GLOBAL_NAMESPACE + 'doc_history';
// 分享队列记录
export const SHARE_QUEUE = GLOBAL_NAMESPACE + 'share_queue';
export const VERSION_NUMBER = GLOBAL_NAMESPACE + 'VERION_NUMBER';
// 计划页面上次点击的类型
export const LAST_PLAN_TIME_TYPE = GLOBAL_NAMESPACE + 'last_plan_time_type';
// 项目导航中选中的项目技术类型
export const SELECTED_PROJECT__TECH_STATUS = GLOBAL_NAMESPACE + 'selected_project_tech_status';


// export const SELECTED_PANEL = GLOBAL_NAMESPACE + 'selected_panel';
// export const SELECTED_MAJOR = GLOBAL_NAMESPACE + 'selected_major';

class LocalStore {
    // 静态键名常量（保持私有性）
    private static SELECTED_TECH_KEY = 'teamerp.selected_tech';
    private static SELECTED_PRODUCT_KEY = 'teamerp.selected_product';
    private static SELECTED_USER_KEY = 'teamerp.selected_user';
    // 记录项目导航里选中的部门
    private static SELECTED_INSTITUTION_ID = 'teamerp.selected_institution_id';
    // 记录待办页面里是否选中个人
    private static SELECTED_MINE = 'teamerp.selected_mine';
    // 记录待办页面里是否选中本部门
    private static SELECTED_INSTITUTION = 'teamerp.selected_institution';
    // 记录项目工具里选中的项目id
    private static SELECTED_DETAIL_ID = 'teamerp.selected_detail_id';
    // 记录项目工具里选中的页签
    private static SELECTED_MENU_key = 'teamerp.selected_menu_key';
    // 记录品牌项目工具里选中的页签
    private static SELECTED_BRAND_MENU_key = 'teamerp.selected_brand_menu_key';
    // 记录人事项目里选中的职位id
    private static SELECTED_POSITION_ID = 'teamerp.selected_position_id';
    // 记录人事项目里选中的用户状态
    private static SELECTED_USER_STATUS = 'teamerp.selected_user_status';
    // 记录人事项目里选中的用户专业
    private static SELECTED_USER_TALENT_CATEGORY = 'teamerp.selected_user_talent_category';
    // 记录人事项目里选中的应聘者userId
    private static SELECTED_RECRUIT_USER_ID = 'teamerp.selected_recruit_user_id';
    // 记录最近访问的工作包id
    private static SELECTED_SERVICE_PACKAGE_ID = 'teamerp.selected_service_package_id';
    // 记录最近访问的服务id
    private static SELECTED_SERVICE_TASK_ID = 'teamerp.selected_service_task_id';
    // 记录最近访问的服务类型
    private static SELECTED_PRODUCT_LIST_ID = 'teamerp.selected_product_list_id';


    // 技术分类（字符串类型）
    getSelectedTechCategory(): string | null {
        return this.get(LocalStore.SELECTED_TECH_KEY);
    }
    setSelectedTechCategory(value: string | null): void {
        value ? this.set(LocalStore.SELECTED_TECH_KEY, value) : this.remove(LocalStore.SELECTED_TECH_KEY);
    }

    // 产品分类（字符串类型）
    getSelectedProductCategory(): string | null {
        return this.get(LocalStore.SELECTED_PRODUCT_KEY);
    }
    setSelectedProductCategory(value: string | null): void {
        value ? this.set(LocalStore.SELECTED_PRODUCT_KEY, value) : this.remove(LocalStore.SELECTED_PRODUCT_KEY);
    }

    // 用户分类（数字类型）

    getSelectedUserCategory(): number | null {
        const value = this.get(LocalStore.SELECTED_USER_KEY);
        return typeof value === 'number' ? value : null; // 确保返回数字或null[2,10](@ref)
    }
    setSelectedUserCategory(value: number | null): void {
        value !== null ? this.set(LocalStore.SELECTED_USER_KEY, value) : this.remove(LocalStore.SELECTED_USER_KEY);
    }

    getSelectedMine(): boolean | null {
        return this.get(LocalStore.SELECTED_MINE);
    }
    setSelectedMine(value: boolean | null): void {
        value !== null ? this.set(LocalStore.SELECTED_MINE, value) : this.remove(LocalStore.SELECTED_MINE);
    }
    getSelectedInstitution(): boolean | null {
        return this.get(LocalStore.SELECTED_INSTITUTION);
    }
    setSelectedInstitution(value: boolean | null): void {
        value !== null ? this.set(LocalStore.SELECTED_INSTITUTION, value) : this.remove(LocalStore.SELECTED_INSTITUTION);
    }
    getSelectedDetailId(): number | null {
        return this.get(LocalStore.SELECTED_DETAIL_ID);
    }
    setSelectedDetailId(value: number | null): void {
        value !== null ? this.set(LocalStore.SELECTED_DETAIL_ID, value) : this.remove(LocalStore.SELECTED_DETAIL_ID);
    }
    getSelectedMenuKey(): string | null {
        return this.get(LocalStore.SELECTED_MENU_key);
    }
    setSelectedMenuKey(value: string | null): void {
        value !== null ? this.set(LocalStore.SELECTED_MENU_key, value) : this.remove(LocalStore.SELECTED_MENU_key);
    }

    getSelectedBrandMenuKey(): string | null {
        return this.get(LocalStore.SELECTED_BRAND_MENU_key);
    }
    setSelectedBrandMenuKey(value: string | null): void {
        value !== null ? this.set(LocalStore.SELECTED_BRAND_MENU_key, value) : this.remove(LocalStore.SELECTED_BRAND_MENU_key);
    }

    getSelectedPositionId(): number | null {
        return this.get(LocalStore.SELECTED_POSITION_ID);
    }
    setSelectedPositionId(value: number | null): void {
        value !== null ? this.set(LocalStore.SELECTED_POSITION_ID, value) : this.remove(LocalStore.SELECTED_POSITION_ID);
    }
    getSelectedProductListId(): number | null {
        return this.get(LocalStore.SELECTED_PRODUCT_LIST_ID);
    }
    setSelectedProductListId(value: number | null): void {
        value !== null ? this.set(LocalStore.SELECTED_PRODUCT_LIST_ID, value) : this.remove(LocalStore.SELECTED_PRODUCT_LIST_ID);
    }

    getSelectedUserStatus(): number | null {
        return this.get(LocalStore.SELECTED_USER_STATUS);
    }
    setSelectedUserStatus(value: number | null): void {
        value !== null ? this.set(LocalStore.SELECTED_USER_STATUS, value) : this.remove(LocalStore.SELECTED_USER_STATUS);
    }

    getSelectedUserTalentCategory(): number | null {
        return this.get(LocalStore.SELECTED_USER_TALENT_CATEGORY);
    }
    setSelectedUserTalentCategory(value: number | null): void {
        value !== null ? this.set(LocalStore.SELECTED_USER_TALENT_CATEGORY, value) : this.remove(LocalStore.SELECTED_USER_TALENT_CATEGORY);
    }
    getSelectedRecruitUserId(): number | null {
        return this.get(LocalStore.SELECTED_RECRUIT_USER_ID);
    }
    setSelectedRecruitUserId(value: number | null): void {
        value !== null ? this.set(LocalStore.SELECTED_RECRUIT_USER_ID, value) : this.remove(LocalStore.SELECTED_RECRUIT_USER_ID);
    }

    getSelectedServicePackageId(): number | null {
        return this.get(LocalStore.SELECTED_SERVICE_PACKAGE_ID);
    }
    setSelectedServicePackageId(value: number | null): void {
        value !== null ? this.set(LocalStore.SELECTED_SERVICE_PACKAGE_ID, value) : this.remove(LocalStore.SELECTED_SERVICE_PACKAGE_ID);
    }

    getSelectedServiceTaskId(): number | null {
        return this.get(LocalStore.SELECTED_SERVICE_TASK_ID);
    }
    setSelectedServiceTaskId(value: number | null): void {
        value !== null ? this.set(LocalStore.SELECTED_SERVICE_TASK_ID, value) : this.remove(LocalStore.SELECTED_SERVICE_TASK_ID);
    }

    getSelectedInstitutionId(): number | null {
        const value = this.get(LocalStore.SELECTED_INSTITUTION_ID);
        return typeof value === 'number' ? value : null; // 确保返回数字或null[2,10](@ref)
    }
    setSelectedInstitutionId(value: number | null): void {
        value !== null ? this.set(LocalStore.SELECTED_INSTITUTION_ID, value) : this.remove(LocalStore.SELECTED_INSTITUTION_ID);
    }

    public get(key: string) {
        let item = localStorage.getItem(key);
        if (item == "undefined") {
            return null;
        }
        return JSON.parse(localStorage.getItem(key) || 'null') || null;
    }

    public set(key: string, value: any) {
        localStorage.setItem(key, JSON.stringify(value));
    }

    public remove(key: string): void {
        localStorage.removeItem(key);
    }

    get token(): string {
        return this.get(AUTHORIZATION) || '';
    }

    set token(value: string) {
        this.set(AUTHORIZATION, value);
    }

    get userId(): number {
        return +this.get(USER_ID) || null;
    }
    set userId(value: number) {
        this.set(USER_ID, value);
    }
    get userUuid(): string {
        return this.get(USER_UUID) || null;
    }
    set userUuid(value: string) {
        this.set(USER_UUID, value);
    }

    get userProjectId(): number {
        return +this.get(USER_PROJECT_ID) || null;
    }
    set userProjectId(value: number) {
        this.set(USER_PROJECT_ID, value);
    }

    get lastUrl(): string {
        return this.get(LAST_URL) || null;
    }

    set lastUrl(value: string) {
        this.set(LAST_URL, value);
    }

    get selectedProjectTechStatus(): number {
        return this.get(SELECTED_PROJECT__TECH_STATUS) || null;
    }

    set selectedProjectTechStatus(value: number) {
        this.set(SELECTED_PROJECT__TECH_STATUS, value);
    }

    get lastPlanTimeType(): { [key: number]: number } {
        return this.get(LAST_PLAN_TIME_TYPE) || null;
    }

    public setLastPlanTimeType(key: number, value: number) {
        let last = this.get(LAST_PLAN_TIME_TYPE) || null;
        if (!last) {
            last = {};
        }
        last[key] = value;
        this.set(LAST_PLAN_TIME_TYPE, last);
    }

    get name(): string {
        return this.get(USER_NAME) || '';
    }
    set name(value: string) {
        this.set(USER_NAME, value);
    }

    get mobile(): string {
        return this.get(USER_MOBILE) || '';
    }
    set mobile(value: string) {
        this.set(USER_MOBILE, value);
    }

    get password(): string {
        return this.get(REMEMBER_PASSWORD) || '';
    }
    set password(value: string) {
        this.set(REMEMBER_PASSWORD, value);
    }

    get projectUuid(): string {
        return this.get(PROJECT_UUID) || '';
    }
    set projectUuid(value: string) {
        this.set(PROJECT_UUID, value);
    }

    get projectName(): string {
        return this.get(PROJECT_NAME) || '';
    }
    set projectName(value: string) {
        this.set(PROJECT_NAME, value);
    }

    get currentUrl(): string {
        return this.get(CURRENT_URL) || '';
    }
    set currentUrl(value: string) {
        this.set(CURRENT_URL, value);
    }
    get projectUrls() {
        return this.get(PROJECT_URLS)
    }

    set projectUrls(value: { [key: number]: string }) {
        this.set(PROJECT_URLS, value)
    }

    get versionNumber(): string | null {
        return this.get(VERSION_NUMBER);
    }


    set versionNumber(version: string | null) {
        if (version == null) {
            this.remove(VERSION_NUMBER);
        } else {
            this.set(VERSION_NUMBER, version);
        }
    }

    public setAuthority(types: number[]) {
        if (types == null) {
            this.remove(AUTHORITY);
            return;
        }
        this.set(AUTHORITY, types);
    }

    public getAuthority() {
        return this.get(AUTHORITY);
    }

    public getUser() {
        return this.get(USER_META);
    }

    // 根据projectId获得上次打开的页面
    public getLastUrlByProject(projectId: number) {
        const projectUrls = this.get(PROJECT_URLS);
        if (projectUrls == null) return null;
        const url = projectUrls[projectId];
        return url;
    }

    // 设置projectId上次打开的页面
    public setLastUrl(projectId: number, url: string) {
        let projectUrls = this.get(PROJECT_URLS);
        if (projectUrls == null) {
            projectUrls = {};
            projectUrls[projectId] = url;
        } else {
            projectUrls[projectId] = url;
        }
        return this.set(PROJECT_URLS, projectUrls);
    }

    clearProjectInfo() {
        // this.remove(AUTHORITY);
        this.remove(PROJECT_UUID);
        this.remove(PROJECT_NAME);
    }

    clear() {
        this.remove(AUTHORIZATION);
        this.remove(PROJECT_UUID);
        this.remove(PROJECT_NAME);
        this.remove(USER_ID);
        this.remove(USER_NAME);
        this.remove(USER_META);
        this.remove(AUTHORITY);
        this.remove(USER_PROJECT_ID);
        this.remove(PROJECT_URLS);
        this.remove(LAST_URL);
        this.remove(SHARE_QUEUE);
    }
}

export default new LocalStore();